<template lang="html">
  <b-container>
    <b-row>
      <b-col>
        <h4>Reset your password</h4>
        <b-form @submit="reset">
          <b-form-group
            id="exampleInputGroup3"
            label="Email address:"
            label-for="exampleInput3"
            description="We'll email you reset instructions."
          >
            <b-form-input
              id="exampleInput3"
              v-model="email"
              type="email"
              required
              placeholder="Enter email"
            />
          </b-form-group>
          <b-button :disabled="submitted" type="submit" variant="primary">
            Reset
          </b-button>
        </b-form>
        <p v-show="$store.state.reset_error" class="alert alert-danger mt-3">
          Error: We could not find that email address.
        </p>
        <p v-show="$store.state.reset_sent" class="alert alert-success mt-3">
          Reset directions sent. Please check your email.
        </p>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
export default {
  name: "PasswordReset",
  data() {
    return {
      email: "",
      submitted: false
    };
  },
  computed: {
    reset_error() {
      return this.$store.state.reset_error;
    }
  },
  watch: {
    reset_error(value) {
      if (value) {
        this.submitted = false;
      }
    }
  },
  methods: {
    reset(evt) {
      evt.preventDefault();
      console.log("reset");
      this.submitted = true;
      this.$store.dispatch("send_reset", { email: this.email });
    }
  }
};
</script>

<style lang="css" scoped></style>
